import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import Nosotros from './pages/Nosotros';
import ProgramasClientes from './pages/ProgramasClientes';
export function AppRouter() {
  return <BrowserRouter data-id="element-7">
      <Routes data-id="element-8">
        <Route path="/" element={<App data-id="element-10" />} data-id="element-9" />
        <Route path="/nosotros" element={<Nosotros data-id="element-12" />} data-id="element-11" />
        <Route path="/programas-clientes" element={<ProgramasClientes data-id="element-14" />} data-id="element-13" />
      </Routes>
    </BrowserRouter>;
}